"use client";

const quickNavLinks = [
    { label: "Offtake Terms", href: "#offtake-terms" },
    { label: "Pricing Formula", href: "#pricing-heading" },
    { label: "Risk Allocation", href: "#risk-allocation" },
];

export default function QuickNavLinks() {
    return (
        <div className="flex flex-wrap gap-3 mt-10 items-center justify-center reveal reveal-delay-3">
            {quickNavLinks?.map((link) => (
                <a
                    key={link?.label}
                    href={link?.href}
                    style={{
                        fontFamily: "var(--font-sans)",
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        letterSpacing: "0.08em",
                        textTransform: "uppercase",
                        color: "rgba(255,255,255,0.45)",
                        background: "rgba(255,255,255,0.05)",
                        border: "1px solid rgba(255,255,255,0.1)",
                        padding: "8px 16px",
                        borderRadius: "2px",
                        textDecoration: "none",
                        transition: "color 150ms, border-color 150ms",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#b91c1c";
                        e.currentTarget.style.borderColor = "var(--color-red)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.color = "rgba(255,255,255,0.45)";
                        e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)";
                    }}
                >
                    {link?.label}
                </a>
            ))}
        </div>
    );
}